module.exports = __webpack_public_path__ + "static/media/elephantTut.6f460fba.jpg";